import React from "react";
import WelcomeName from "../WelcomeName";
import "./WelcomeNameContainer.css";
import DownloadIcon from '@mui/icons-material/Download';
const WelcomeNameContainer = ({
  currentComp,
  l1,
  l2,
  pdfUrl
}) => {
  return <>
   <div className="welcome-container">
    <div className="welcome-wrap">
     <div className="welcome-wrap-left gradient-text">
      {currentComp == "TestimonialsPage" ? <p>
      Testimonials
     </p> : currentComp == "CommsBuilder Demo" ? <p>
        Commsbuilder &nbsp;{">"}
        &nbsp;<span>Demo Video</span>
       </p> : currentComp == "User Guide" ? <p className="migrated-style-welcomenamecontainer-cb2355-1">
       <span>Commsbuilder &nbsp;{">"}</span> 
        &nbsp;<span>User Guide</span>
        &nbsp; &nbsp;<a className="downloadbbtn" target="_blank" href={pdfUrl}><DownloadIcon fontSize="small" />Download File</a> 
       </p> : currentComp == "Launch" ? <p>
        Mailer &nbsp;{">"}
        &nbsp;<span>Launch/Nomination/Registration</span>
       </p> : currentComp == "Teaser" ? <p>
        Mailer &nbsp;{">"}
        &nbsp;<span>Teaser</span>
       </p> : currentComp == "Reminder" ? <p>
        Mailer &nbsp;{">"}
        &nbsp;<span>Follow-up/Reminder</span>
       </p> : currentComp == "Nudge" ? <p>
        Mailer &nbsp;{">"}
        &nbsp;<span>Nudge</span>
       </p> : currentComp == "Recognition" ? <p>
        Mailer &nbsp;{">"}
        &nbsp;<span>Recognition</span>
       </p> : currentComp == "Closure" ? <p>
        Mailer &nbsp;{">"}
        &nbsp;<span>Closure/Highlights</span>
       </p> : currentComp == "E-Certificate" ? <p>
        Endorsements &nbsp;{">"}
        &nbsp;<span> E-Certificates</span>
       </p> : currentComp == "Testimonials" ? <p>
        Endorsements &nbsp;{">"}
        &nbsp;<span> Testimonials</span>
       </p> : currentComp == "Viva-Engage-launch" ? <p>
        Social Engagement &nbsp;{">"}
        &nbsp;<span> Viva Engage</span>&nbsp;{">"}
        &nbsp;<span> Launch/Nomination/Registration</span>
       </p> : currentComp == "Viva-Engage-Reminder" ? <p>
        Social Engagement &nbsp;{">"}
        &nbsp;<span> Viva Engage</span>&nbsp;{">"}
        &nbsp;<span> Follow-up/Reminder</span>
       </p> : currentComp == "Viva-Engage-Nudge" ? <p>
        Social Engagement &nbsp;{">"}
        &nbsp;<span> Viva Engage</span>&nbsp;{">"}
        &nbsp;<span> Nudge</span>
       </p> : currentComp == "Viva-Engage-Recognition" ? <p>
        Social Engagement &nbsp;{">"}
        &nbsp;<span> Viva Engage</span>&nbsp;{">"}
        &nbsp;<span> Recognition</span>
       </p> : currentComp == "Dipa-Launch" ? <p>
        Social Engagement &nbsp;{">"}
        &nbsp;<span> Dipa</span>&nbsp;{">"}
        &nbsp;<span> Launch/Nomination/Registration</span>
       </p> : currentComp == "Dipa-Teaser" ? <p>
        Social Engagement &nbsp;{">"}
        &nbsp;<span> Dipa</span>&nbsp;{">"}
        &nbsp;<span> Teaser</span>
       </p> : currentComp == "approver" ? <span>Approval</span> : currentComp == "campaign" ? <span>Campaigns</span> : currentComp == "mycontent" ? <span>MyContent</span> : currentComp == "admin" ? <p>Admin</p> : currentComp == "designer" ? <p>My Designs</p> : currentComp == "design" ? <p>Design</p> : <></>}
      {/* only for "mycontent" and "approval" */}
      {l1 && l2 && <span className="migrated-style-welcomenamecontainer-cb2355-2"> {` > ${l1} > ${l2}`} </span>}
     </div>
     <WelcomeName />
    </div>
    <hr />
   </div>
  </>;
};
export default WelcomeNameContainer;
